import * as React from "react";
import { RouteComponentProps, withRouter, Route, Switch, Redirect } from "react-router";
import { apiAlbumToBPMAlbum, toSortBy } from "src/transformer";
import { AudioVideoProps, CategoryFilterView, AudioVideoDefaultProps, WithToast, SongVersion, SortBy, ContentType, errorToString, DefaultGrid, ListViewHeader, ManagedListView, SongFilter, withToast, resolveCurrentUrl, BPMAlbum, BPMGenre, BPMCategory } from 'bpm-web-generic';
import GenericClassicSmartView from "./GenericClassicSmartView";
import { SortByQueryOptions, PagingInfo, RemixQueryOptions } from "bpm-client-api";
import { mediaAPI, metaAPI } from "src/api/config";

export interface SearchResultProps extends AudioVideoProps, AudioVideoDefaultProps, RouteComponentProps, WithToast {
    search?: string
    page: string;
    category?: string;
    genre?: string;
}
interface SearchResultState {
    apiFilter: any
    albums?: BPMAlbum[]

    songVersions: SongVersion[]
    sortBys: SortBy[]
    keys: string[]
    categories: BPMCategory[]
    genres: BPMGenre[]
}
class SearchResultInner extends React.Component<SearchResultProps, SearchResultState> {

    constructor(props: SearchResultProps) {
        super(props);
        const apiFilter = this.getAPIFilter()
        this.state = {
            apiFilter,
            categories: [],
            genres: [],
            keys: [],
            songVersions: [],
            sortBys: Object.keys(SortByQueryOptions).map((key, index) => {
                return {
                    id: SortByQueryOptions[key],
                    name: GenericClassicSmartView.translateSortByDisplayValue(SortByQueryOptions[key])
                    //Alternativ name: key.toString()
                }
            })
        }
        this.apiFunc = this.apiFunc.bind(this)
    }

    componentDidMount() {
        this.loadCategories()
        this.loadGenres()
        this.loadSongVersions()
        metaAPI.getKeys().then(({ data }) => {
            this.setState({ keys: data })
        })
    }

    componentDidUpdate(prevProps: SearchResultProps) {
        if (prevProps.contentType != this.props.contentType) {
        } else if (prevProps.category != this.props.category) {
            this.setState({ genres: [], apiFilter: this.getAPIFilter() }, () => {
                this.loadGenres()
            })
        } else if (prevProps.genre != this.props.genre) {
            this.setState({ apiFilter: this.getAPIFilter() })
        }
    }

    private apiFunc(_: ContentType, filter: any, pagingInfo: PagingInfo) {
        return mediaAPI.searchAlbum(pagingInfo.limit, pagingInfo.skip, filter.category, `music`, filter.sub_genre, undefined, filter.remix == RemixQueryOptions.Hide ? '1' : '0', filter.show_only, filter.key, undefined, filter.bpm_min, filter.bpm_max, toSortBy(filter.sort_by), filter.keywords).then((data: any) => {
            return {
                ...data,
                data: data.data.map(apiAlbumToBPMAlbum)
            }
        })
    }

    private getAPIFilter() {
        return Object.assign({ sort_by: SortByQueryOptions.DateDes }, (this.state ? this.state.apiFilter : (this.props.location.state || {})), {
            category: this.props.category,
            sub_genre: this.props.genre,
            keywords: (this.props.search || '')
        })
    }

    private loadSongVersions() {
        metaAPI.getVersions('music').then(({ data: songVersions }) => {
            this.setState({
                songVersions: songVersions
            })
        }).catch(err => {
            errorToString(err).forEach(mes => {
                this.props.showToast('danger', mes, () => this.loadSongVersions())
            })
        })
    }

    private loadCategories() {
        metaAPI.getCategories('music').then(({ data: categories }) => {
            this.setState({ categories }, () => {
                if (this.props.category && !this.state.categories.find(c => c.slug == this.props.category)) {
                    this.navigateToCategory()
                }
            })
        }).catch(err => {
            errorToString(err).forEach(mes => {
                this.props.showToast('danger', mes, () => this.loadCategories())
            })
        })
    }

    private loadGenres() {
        if (this.props.category) {
            metaAPI.getGenres('music').then(({ data: genres }) => {
                this.setState({ genres }, () => {
                    if (this.props.genre && !this.state.genres.find(c => c.slug == this.props.genre)) {
                        this.navigateToGenre()
                    }
                })
            }).catch(err => {
                errorToString(err).forEach(mes => {
                    this.props.showToast('danger', mes, () => this.loadGenres())
                })
            })
        } else {
            metaAPI.getGenres('music').then(({ data: genres }) => {
                this.setState({ genres }, () => {
                    if (this.props.genre && !this.state.genres.find(c => c.slug == this.props.genre)) {
                        this.navigateToGenre()
                    }
                })
            }).catch(err => {
                errorToString(err).forEach(mes => {
                    this.props.showToast('danger', mes, () => this.loadGenres())
                })
            })
        }
    }

    private navigateToCategory(slug?: string) {
        if (slug && this.props.search) {
            this.props.history.push(`/${this.props.page}/${this.props.contentType}/${this.props.search}/${encodeURIComponent(slug)}`)
        } else {
            this.props.history.push(`/${this.props.page}/${this.props.contentType}/${this.props.search}`)
        }
    }

    private navigateToGenre(slug?: string) {
        if (slug && this.props.category && this.props.search) {
            this.props.history.push(`/${this.props.page}/${this.props.contentType}/${this.props.search}/${encodeURIComponent(this.props.category as string)}/${encodeURIComponent(slug)}`)
        } else if (slug && this.props.search) {
            this.props.history.push(`/${this.props.page}/${this.props.contentType}/${this.props.search}/genre/${encodeURIComponent(slug)}`)
        } else {
            this.navigateToCategory(this.props.category)
        }
    }

    protected getGenre() {
        return this.state.genres.find(g => g.slug == this.props.genre)
    }
    protected getCategory() {
        return this.state.categories.find(g => g.slug == this.props.category)
    }

    protected submitFilter(bpmInput1?: number, bpmInput2?: number, songVersion?: SongVersion, sortBy?: SortBy, key?: string, hideRemix?: boolean) {
        let apiFilter = Object.assign({}, this.state.apiFilter)
        if (bpmInput1 != undefined && bpmInput2 && parseInt(bpmInput1 as any) < parseInt(bpmInput2 as any)) {
            apiFilter['bpm_min'] = bpmInput1
            apiFilter['bpm_max'] = bpmInput2
        } else {
            apiFilter['bpm_min'] = undefined
            apiFilter['bpm_max'] = undefined
        }
        apiFilter['show_only'] = songVersion
        apiFilter['sort_by'] = (sortBy ? (sortBy.id as SortByQueryOptions) : undefined)
        apiFilter['key'] = key;
        if (hideRemix) {
            apiFilter['remix'] = RemixQueryOptions.Hide
        } else {
            apiFilter['remix'] = RemixQueryOptions.All
        }
        this.props.location.state = apiFilter
        this.setState({ apiFilter })
    }

    public render() {
        if (!Boolean(this.props.search)) {
            return <h3>Please specify a search term</h3>
        }
        return (
            <DefaultGrid>
                <div>
                    <>
                        <p style={{ marginBottom: 0 }}>Sort By</p>
                        <ListViewHeader
                            contentType={this.props.contentType} onContentTypeChange={this.props.onContentTypeChange}
                            showSortBy sortBys={[{
                                id: SortByQueryOptions.DateDes,
                                name: 'Upload Date'
                            }]} sortBy={this.state.sortBys.find(s => s.id == this.state.apiFilter.sort_by)}
                            onSortByChange={(sortBy) => {
                                let apiFilter = Object.assign({}, this.state.apiFilter)
                                apiFilter['sort_by'] = (sortBy ? (sortBy.id as SortByQueryOptions) : undefined)
                                this.props.location.state = apiFilter
                                this.setState({ apiFilter })
                            }} />
                        <ManagedListView {...this.props} context={'Search'} fluid title={`Search results for '${(this.props.search || '')}'`}
                            noAlbumsText={`No Tracks found for your search criteria '${(this.props.search || '')}'`}
                            apiFunc={this.apiFunc} limit={100} contentType={this.props.contentType} apiFilter={this.getAPIFilter()} onError={() => { }} />
                    </>
                </div>
                <div>
                    <CategoryFilterView style={{ marginBottom: '20px' }}
                        genres={this.state.genres} genre={this.getGenre()}
                        categories={this.state.categories} category={this.getCategory()}
                        onGenreChange={(value) => this.navigateToGenre(value ? value.slug : undefined)}
                        onCategoryChange={(value) => this.navigateToCategory(value ? value.slug : undefined)} />
                    <SongFilter songVersions={this.state.songVersions}
                        sortBy={this.state.sortBys.find(s => s.id == this.state.apiFilter.sort_by)}
                        sortBys={this.state.sortBys} keys={this.state.keys} hideRemixes={this.state.apiFilter.remix == RemixQueryOptions.Hide}
                        onSubmitPress={(bpmInput1, bpmInput2, songVersion, sortBy, key, remix) => this.submitFilter(bpmInput1, bpmInput2, songVersion, sortBy, key, remix)} />
                </div>
            </DefaultGrid>
        )
    }
}

const SR = withToast(withRouter(SearchResultInner))
export const SearchResults = withRouter(class SearchResults extends React.Component<SearchResultProps & RouteComponentProps<{ page: string }>> {
    render() {
        return <Switch>
            <Route path={resolveCurrentUrl(this.props.match.url, '/:contentType(audio|video)')} render={(props: RouteComponentProps<{ contentType: ContentType }>) => {
                return <Switch>
                    <Route path={resolveCurrentUrl(props.match.url, '/:search?/genre/:genre?')} render={(searchProps: RouteComponentProps<{ search: string, category?: string, genre?: string }>) => {
                        return <SR {...this.props} page={this.props.match.params.page} genre={window.decodeURIComponentOptional(searchProps.match.params.genre)}
                            contentType={'audio'} onContentTypeChange={(type) => {
                                sessionStorage['lastContentType'] = type
                                this.props.history.push(`/${this.props.match.params.page}/${type}/${searchProps.match.params.search}`)
                            }}
                            search={window.decodeURIComponentOptional(searchProps.match.params.search)} />
                    }} />
                    <Route path={resolveCurrentUrl(props.match.url, '/:search?/:category?/:genre?')} render={(searchProps: RouteComponentProps<{ search: string, category?: string, genre?: string }>) => {
                        return <SR {...this.props} page={this.props.match.params.page} category={window.decodeURIComponentOptional(searchProps.match.params.category)} genre={window.decodeURIComponentOptional(searchProps.match.params.genre)}
                            contentType={'audio'} onContentTypeChange={(type) => {
                                sessionStorage['lastContentType'] = type
                                this.props.history.push(`/${this.props.match.params.page}/${type}/${searchProps.match.params.search}`)
                            }}
                            search={window.decodeURIComponentOptional(searchProps.match.params.search)} />
                    }} />
                </Switch>
            }} />
            <Route>
                <Redirect to={resolveCurrentUrl(this.props.match.url, '/' + (sessionStorage['lastContentType'] || 'audio'))} />
            </Route>
        </Switch>
    }
})


// WEBPACK FOOTER //
// ./src/pages/SearchResult.tsx